jQuery(document).ready(function() {
    if(!window.allImages) return;
    if(window.allImages.length == 0) return;
    var galleryWrapper = jQuery('.gallery-modal-wrapper');
    var overelayModal = jQuery('.overlay-gallery');
    var sliderHtml = jQuery('.gallery-slider');
    var body = jQuery('body');
    var html = jQuery('html');
    var loadMore = jQuery('.gallery-section .load-more');
    function closeModal() {
        html.removeClass('overflow');
        body.removeClass('overflow');
        if(sliderHtml) {
            sliderHtml.trigger('destroy.owl.carousel');
        }
        sliderHtml.html('');
        overelayModal.removeClass('open');
        galleryWrapper.removeClass('open')
    }
    jQuery(document).on('click','.gallery-wrapper-outer .gallery-item',function(e) {
        e.preventDefault();
        for (var i= 0; i<window.allImages.length;i++) {
            var sliderItem = '<div class="item"><img src="'+window.allImages[i].large+'" alt="'+window.allImages[i].title+'"><div class="description">'+window.allImages[i].description+'<div class="signature">'+ window.allImages[i].signature +'</div></div><div class="image-number">'+parseInt(i+1)+'&nbsp;/&nbsp;'+ window.allImages.length +'</div></div>';
            sliderHtml.append(sliderItem);
        }
        sliderHtml.owlCarousel({
            loop:true,
            nav:true,
            items:1,
            onInitialized:initializeFunction
        });
        function initializeFunction() {
            overelayModal.addClass('open');
            galleryWrapper.addClass('open');
            html.addClass('overflow');
            body.addClass('overflow');
        }
        sliderHtml.trigger('to.owl.carousel', jQuery(this).index())
        jQuery('.gallery-close').off('click').on('click', function() {
            closeModal();
        })
        jQuery(document).off('keydown').on('keydown',function(e) {
            switch(e.which) {
                case 37: // left
                sliderHtml.trigger('prev.owl.carousel');
                break;
        
                case 39: // right
                sliderHtml.trigger('next.owl.carousel');
                break;
        
                default: return; // exit this handler for other keys
            }
            e.preventDefault(); // prevent the default action (scroll / move caret)
        });
        // overelayModal.off('click').on('click', function() {
        //     closeModal();
        // })
    })
    jQuery(this).keyup(function(e) {
        if (e.key === "Escape" && galleryWrapper.hasClass('open')) {
            closeModal();
        }
    });
    jQuery('.embed_icon a').on('click',function() {       
        var embedText;
        if(body.hasClass('en')) {
            embedText = 'Code is copied';
             
        } else if(body.hasClass('sr')) {
            embedText = 'Код је копиран';
           
        } else if(body.hasClass('lat')){
            embedText = 'Kod je kopiran';
        }
        var embedCode = jQuery(this).data('embed-code') + '<script>window.allImages='+JSON.stringify(window.allImages)+'</script>';
        console.log(embedCode)
    	var textArea = document.createElement("textarea");
		textArea.style.position = 'fixed';
		textArea.style.top = 0;
		textArea.style.left = 0;
		textArea.style.width = '0.4em';
		textArea.style.height = '0.4em';
		textArea.style.padding = 0;
		textArea.style.border = 'none';
		textArea.style.outline = 'none';
		textArea.style.boxShadow = 'none';
		textArea.style.background = 'transparent';
		textArea.value = embedCode;
		textArea.class = 'embed-textarea';
  		if(!jQuery('.embed-textarea')[0]){
			document.body.appendChild(textArea);
  		}
		textArea.select();
  		document.execCommand("Copy");
        document.body.removeChild(textArea);
  		var copiedTitle = '<div class="embed_title">'+embedText+'</div>';
  		if(!jQuery('.embed_title')[0]) {
              console.log('usao')
  			jQuery(this).parents('.socials-wrapper').append(copiedTitle);
  		}
		setTimeout(function() {
			jQuery('.embed_title').remove();;
		},2500)
    })
    var loadMoreFunction = function() {
        var numberImagesInit = jQuery('.gallery-wrapper-outer .gallery-item').length;
        if(window.allImages.length > numberImagesInit) {
            loadMore.show();
        }
        var page = 1;
        loadMore.on('click',function(e) {
            e.preventDefault();
            var limit;
            if (window.allImages.length - page*numberImagesInit <= numberImagesInit){
                limit = window.allImages.length;
                loadMore.hide();
                populateGallery();
            } else {
                limit = page*numberImagesInit + numberImagesInit;
                populateGallery()
                page ++
            }
            function populateGallery() {
                for(var i = page*numberImagesInit; i <limit; i++) {
                    var galleryItem = '<div class="gallery-item third-item-layout"><a href="#"><div class="image-wrapper"><img src="'+window.allImages[i].small+'" alt="'+window.allImages[i].title+'" title="'+ window.allImages[i].signature +'"></div></a></div>';
                    jQuery('.gallery-wrapper').append(galleryItem);
                }
            } 
        })
    }
    var onResize = function() {

    }

    var onScroll = function() {
       
    }
    loadMoreFunction();
    onResize()
    jQuery(window).scroll(onScroll)
    jQuery(window).resize(onResize);
})







